import React from 'react';
import { Thermometer, Wrench, Building2, ClipboardCheck, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const services = [{
  icon: Thermometer,
  title: 'Installation',
  description: 'Bespoke commercial AC installations nationwide. Daikin and Mitsubishi specialists for single-split to large-scale VRV/VRF projects.'
}, {
  icon: Wrench,
  title: 'Maintenance',
  description: 'Planned preventative maintenance with detailed photo reports and full compliance documentation. 6 and 12-month contracts.'
}, {
  icon: Building2,
  title: 'Facilities management',
  description: 'White-label and in-house FM support for landlords, property managers, and M&E contractors nationwide.'
}, {
  icon: ClipboardCheck,
  title: 'TM44 compliance',
  description: 'In-house TM44 energy efficiency inspections for non-domestic systems over 12kW. Required every 5 years.'
}];
export function Services() {
  return <section id="services" className="py-24 bg-[#E8F0F8]" data-id="element-509">
      <div className="container mx-auto px-6" data-id="element-510">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8" data-id="element-511">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-512">
            <span className="text-accent font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-513">
              Our Services
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-primary-dark" data-id="element-514">
              What we do
            </h2>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-515">
            <Link to="/services" className="inline-flex items-center text-sm font-medium text-accent hover:text-primary-dark transition-colors group" data-id="element-516">
              View all services
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-517" />
            </Link>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 gap-x-24 gap-y-0" data-id="element-518">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="py-12 border-b border-primary-dark/10 last:border-b-0 md:odd:border-r md:odd:pr-12 md:even:pl-12" data-id="element-519">
              <div className="flex items-start gap-6" data-id="element-520">
                <div className="flex-shrink-0" data-id="element-521">
                  <service.icon className="w-10 h-10 text-accent stroke-[1.5]" data-id="element-522" />
                </div>
                <div data-id="element-523">
                  <h3 className="text-3xl font-serif mb-4 text-primary-dark" data-id="element-524">
                    {service.title}
                  </h3>
                  <p className="text-primary-dark/70 leading-relaxed" data-id="element-525">
                    {service.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}